export default class Model {
    constructor(attributes = {}) {
        this.fill(attributes)
    }

    static make(attributes = {}) {
        return Array.isArray(attributes)
            ? attributes.map(nested => new this(nested))
            : new this(attributes)
    }

    fill(attributes = {}) {
        this.setAttributes(attributes)
        this.wrapRelationships()
        this.filled()
        return this
    }

    setAttributes(attributes) {
        Object.assign(this, attributes)
    }

    getAttributes() {
        return {...this}
    }

    only(keys) {
        return _.pick(this, keys)
    }

    except(keys) {
        return _.omit(this, keys)
    }

    getFormAttributes() {
        return this.getAttributes()
    }

    static parseAttributes(attributes = {}) {
        return attributes
    }

    clone() {
        return this.constructor.make({...this.getAttributes()})
    }

    wrapRelationships() {
        let attributes = this.getAttributes() || {}
        let relationships = this.getRelationships() || {}

        Object.keys(relationships).forEach(key => {
            if (attributes.hasOwnProperty(key) && attributes[key]) {
                attributes[key] = relationships[key].make(attributes[key])
            }
        })

        this.setAttributes(attributes)
    }

    getRelationships() {
        return {}
    }

    filled() {
        // Override this to add logic after the model has been filled...
    }

    key() {
        return this.id
    }

    async refresh () {
        const model = await this.constructor.find(this.key())
        this.fill(model)
    }

    toDropdown() {
        return { label: this.name, value: this.key() }
    }

    static parseDropdownAttributes(attributes = {}, searchableDropdownFields = []) {
        _.forEach(attributes, function (attribute, attributeKey) {
            if (! searchableDropdownFields.includes(attributeKey)) return

            // Parses multiple dropdown objects into an array of ids.
            if (Array.isArray(attribute)) {
                attributes[attributeKey] = attribute.map(nestedAttribute => {
                    if (_.isNull(nestedAttribute) || ! _.has(nestedAttribute, 'value')) return nestedAttribute
                    return nestedAttribute['value']
                })
                return
            }

            // Parses a single dropdown object into an id.
            if (_.isNull(attribute) || ! _.has(attribute, 'value')) return
            attributes[attributeKey] = attribute['value']
        })

        return attributes
    }
}
